// Types sourced from the generated OpenAPI schema (../api.gen.d.ts).
// Regenerate with scripts/generate-www-api-types.sh after backend changes.
import type { components } from '../api.gen';

// 'deleted' means the job was explicitly torn down. Results may still exist.
export type JobStatus = components['schemas']['JobStatusResponse']['status'];

export type ImportStatus =
  components['schemas']['ImportStatusDetail']['status'];
export type ImportStatusDetail = components['schemas']['ImportStatusDetail'];
export type ImportSummary = components['schemas']['ImportSummary'];
export type EvalSetDetails = components['schemas']['EvalSetDetails'];
export type ScanDetails = components['schemas']['ScanDetails'];
export type PodCondition = components['schemas']['PodCondition'];
export type ContainerStatus = components['schemas']['ContainerStatus'];
export type PodEvent = components['schemas']['PodEvent'];
export type PodStatusInfo = components['schemas']['PodStatusInfo'];
export type PodStatusData = components['schemas']['PodStatusData'];
export type AdmissionStatus = components['schemas']['AdmissionStatus'];
export type JobStatusResponse = components['schemas']['JobStatusResponse'];

export function isEvalSetDetails(
  details: EvalSetDetails | ScanDetails
): details is EvalSetDetails {
  return !('scan_id' in details);
}

export function isTerminal(
  status: JobStatus
): status is 'complete' | 'failed' | 'deleted' {
  return status === 'complete' || status === 'failed' || status === 'deleted';
}

// --- Live eval-set status (per-task / per-sample drilldown) ---------------

export type MetricsQueryResult = components['schemas']['MetricsQueryResult'];
export type SamplePhase = components['schemas']['SampleStatus']['phase'];
export type EventBrief = components['schemas']['EventBrief'];
export type SampleStatus = components['schemas']['SampleStatus'];
export type StatusProgress = components['schemas']['StatusProgress'];
export type TaskStatus = components['schemas']['TaskStatus'];
export type WaitingSample = components['schemas']['WaitingSample'];
export type EvalSetStatus = components['schemas']['EvalSetStatus'];
export type EvalSetStatusResponse =
  components['schemas']['EvalSetStatusResponse'];
